import React from 'react';
import styles from './SFNavContentLink.module.scss';
import { SFChip, SFIcon, SFIconButton, SFMenu, SFMenuItem } from 'sfui';
import { SFNavLink } from '../../SFNavLink';
import { InteractiveBox } from 'ui-smartforce-settings';
import { UseSFNavContentLink } from './hooks/UseSFNavContentLink';

export interface SFNavContentLinkProps {
  link: SFNavLink;
  isCollapsed?: boolean;
  isPanel?: boolean;
  disabled?: boolean;
  selected?: boolean;
  isChild?: boolean;
  onDrawerClose?: () => void;
}

const SFNavContentLink = ({
  link,
  isCollapsed = false,
  isPanel,
  disabled = false,
  selected,
  isChild = false,
  onDrawerClose
}: SFNavContentLinkProps): React.ReactElement<SFNavContentLinkProps> => {
  const {
    location,
    open,
    menuOpen,
    anchorEl,
    active,
    onClick,
    onCollapsedSubMenuButtonClick,
    onMenuClose,
    onMenuItemClick
  } = UseSFNavContentLink({ isCollapsed, isPanel, onDrawerClose });

  const linkStyles = `${styles.link} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''} ${active ? styles.active : ''} ${isChild ? styles.isChildren : ''}`;

  return (
    <div className={styles.container}>
      <InteractiveBox className={linkStyles} onClick={(e) => onClick(e, link)}>
        {selected && !isChild && <div className={styles.selectedBorder} />}

        {link.icon && (
          <SFIcon className={styles.icon} icon={link.icon} size={20} />
        )}

        {!isCollapsed && <span className={styles.label}>{link.label}</span>}

        {!isCollapsed && link.chip && (
          <span className={styles.chip}>
            <SFChip sfColor="primary" label={link.chip} size="small" />
          </span>
        )}

        {link.children && !isCollapsed && (
          <div className={styles.openBtn}>
            <SFIconButton
              sfSize={isPanel ? 'small' : 'tiny'}
              sfIcon={open ? 'Up-2' : 'Down-2'}
              onClick={(e) => onCollapsedSubMenuButtonClick(e)}
            />
          </div>
        )}
      </InteractiveBox>

      {link.children && link.children.length > 0 && open && !isCollapsed && (
        <ul className={styles.children}>
          {link.children.map((link: SFNavLink) => (
            <li key={`link-${link.label}`}>
              <SFNavContentLink
                link={link}
                selected={location.pathname.includes(link.pathname as string)}
                isChild
                isPanel={isPanel}
                onDrawerClose={onDrawerClose}
              />
            </li>
          ))}
        </ul>
      )}

      {link.children && link.children.length > 0 && menuOpen && isCollapsed && (
        <SFMenu
          PaperProps={{ className: styles.menuPaper }}
          MenuListProps={{ className: styles.menu }}
          open={menuOpen}
          onClose={onMenuClose}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          getContentAnchorEl={null}
          variant="menu"
        >
          {link.children.map((link: SFNavLink) => (
            <SFMenuItem
              className={styles.menuItem}
              key={`link-${link.label}`}
              onClick={() => onMenuItemClick(link)}
              selected={location.pathname.includes(link.pathname as string)}
            >
              {link.label}
            </SFMenuItem>
          ))}
        </SFMenu>
      )}
    </div>
  );
};

export default SFNavContentLink;
